import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MapPin, Clock } from "lucide-react";
import "./Contact.css";
import mapImage from "../assets/location.png";

const MAPS_URL = "https://maps.app.goo.gl/MjzuXp7gDD6bn5Pn6";
const WHATSAPP_URL = "https://wa.me/306949794405";

export default function Contact() {
  const openGoogleMaps = () => window.open(MAPS_URL, "_blank", "noopener,noreferrer");
  const openWhatsapp = () => window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">Get In Touch</p>
          <h2 className="section-title">Visit our showroom</h2>
        </div>

        <div className="contact-container">
          <div className="contact-card">
            <div className="contact-row" onClick={openGoogleMaps}>
              <div className="contact-icon-wrapper">
                <MapPin size={20} />
              </div>
              <div className="contact-text">
                <h4>Visit Us</h4>
                <p>Σιθωνίας 2ο χλμ, Nea Moudania 632 00, Greece</p>
              </div>
            </div>

            <div className="divider" />

            <div className="contact-row" onClick={openWhatsapp}>
              <div className="contact-icon-wrapper">
                <FaWhatsapp size={20} />
              </div>
              <div className="contact-text">
                <h4>WhatsApp</h4>
                <p>+30 694 979 4405</p>
                <p>Contact us for orders or any questions</p>
              </div>
            </div>

            <div className="divider" />

            <div className="contact-row">
              <div className="contact-icon-wrapper">
                <Clock size={20} />
              </div>
              <div className="contact-text">
                <h4>Opening Hours</h4>
                <p>Monday to Saturday: 8 AM – 6 PM</p>
              </div>
            </div>

            <button type="button" className="btn contact-btn" onClick={openWhatsapp}>
              <FaWhatsapp size={20} />
              Contact Via WhatsApp
            </button>
          </div>

          <div className="map-container" onClick={openGoogleMaps}>
            <img src={mapImage} alt="Our location on the map" className="map-image" />
            <div className="map-overlay">Click to Open Google Maps</div>
          </div>
        </div>
      </div>
    </section>
  );
}
